import './loginform.scss';
import { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { Form, Row, Col, Button, Spinner } from 'react-bootstrap';
import { useFormik } from "formik";
import * as Yup from "yup";
import { useMutation } from '@apollo/client';
import { withRouter } from 'react-router-dom';
import { LOGIN_USER } from '../../../gql/auth/mutation';
import EyeIcon from '../../../assets/images/eye_icon.svg';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

const LogInForm = ({ history }) => {
    // Initialize a boolean state
    const [passwordShown, setPasswordShown] = useState(false);
    const [loginUser, { loading, error, data }] = useMutation(LOGIN_USER)
    // const [errorMessage, setErrorMessage] = useState('')

    useEffect(() => {
        const userToken = localStorage.getItem('token')
        const userRToken = localStorage.getItem('refreshtoken')
        const user = JSON.parse(localStorage.getItem('user'))
        if(userToken && userRToken && user){
            // history.push('/home')
            history.push('/dashboard')
        }
        else{
            history.push('/')
        }
        // eslint-disable-next-line
    }, [])

    const togglePassword = () => {
        setPasswordShown(!passwordShown);
    };

    const formik = useFormik({
        initialValues: {
            email: "",
            password: ""
        },
        validationSchema: Yup.object({
            email: Yup.string()
                .email("Email should be valid")
                .required("Email is required")
                .matches(/^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, "Email should be valid"),

            password: Yup.string()
                .required("Password is required")
        }),
        onSubmit: (values) => {
            try {
                loginUser({
                    variables: {
                        loginInput: values
                    }
                })
            }
            catch (e) {
                console.error(e)
            }
        }
    })

    if (data) {
        if (data?.loginUser?.access_token) {
            localStorage.setItem('token', data?.loginUser?.access_token)
            localStorage.setItem('refreshtoken', data?.loginUser?.refresh_token)
            let user = {
                name: data?.loginUser?.user?.firstName,
                role: data?.loginUser?.user?.role,
                paid: data?.loginUser?.user?.paid,
                twilioTested: data?.loginUser?.user?.tested,
                smtpTested: data?.loginUser?.user?.smtpTested,
                twilioSaved: false,
                smtpSaved: false,
                expirationDate: data?.loginUser?.user?.expirationDate
            }
            localStorage.setItem('user', JSON.stringify(user))
            history.push('/dashboard')
        }
    }

    let errorMessage = '';
    if (error) {
        // if(error.networkError && typeof window !== 'undefined' && !window.navigator.onLine){
        //     setErrorMessage("Check Your Network, Your Browser Is Offline")
        // }
        if (error.message) {
            // setErrorMessage(error.message)
            errorMessage = error.message
        }
        // setErrorMessage("Something Went Wrong !")
        if (!error.message) {
            errorMessage = "Something Went Wrong !"
        }
    }

    return (
        <>
            <Form className="logInForm" onSubmit={formik.handleSubmit}>
                <Row className="mb-4">
                    {
                        errorMessage && <p className="error">{errorMessage}</p>
                    }
                    <Form.Group as={Col} md="12" controlId="email">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            name="email"
                            type="text"
                            placeholder="Enter your email"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className={formik.errors.email && formik.touched.email && "error"}
                        />
                        {
                            formik.errors.email && formik.touched.email &&
                            (
                                <div className="input-feedback">{formik.errors.email}</div>
                            )
                        }
                    </Form.Group>
                </Row>
                <Row className="mb-4">
                    <Form.Group className="pwd-wrapper" as={Col} md="12" controlId="password">
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                            name="password"
                            type={passwordShown ? "text" : "password"}
                            placeholder="Enter your password"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className={formik.errors.password && formik.touched.password && "error"}
                        />
                        <span className={passwordShown ? "hide-pwd password-show" : "show-pwd password-show"} onClick={togglePassword}><img className="view-icon" src={EyeIcon} alt="view" /></span>
                        {
                            formik.errors.password && formik.touched.password &&
                            (
                                <div className="input-feedback">{formik.errors.password}</div>
                            )
                        }
                    </Form.Group>
                </Row>
                <p className="forgotPassword">
                    <Link to='/forgot-password'>Forgot Password</Link>
                </p>
                {/* <Button className='solid-button' type="submit" disabled={isSubmitting}>Sign In</Button> */}
                {
                    (loading && !error) ?
                        <Button className='solid-button'>Sign In
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                        </Button>
                        :
                        <Button className='solid-button' type="submit">Sign In</Button>

                }
            </Form>

            {/* <ToastContainer /> */}

        </>
    )
}

export default withRouter(LogInForm);
